// Dashboard.jsx
import { useState, useEffect } from "react";
import SidebarUser from "../Component/SidebarUser";
import SidebarUserTeam from "../Component/SidebarUserTeam";
import SidebarTeamList from "../Component/SidebarTeamList";
import SidebarUserTeamOverall from "../Component/SidebarUserTeamOverall";

import HeaderUser from "../Component/HeaderUser";
import { FaRobot } from "react-icons/fa6";
import SidebarReport from "../Component/SidebarReport";

export default function Dashboard({
  isNewChat,
  children,
  userDetails,
  onLogout,
  getChatBookmarkData,
  getChatTeamsBookmarkData,
  selectChatBookMark,
  chatMarkIdInit,
  pageName,
  switchToAdmin,
  openAIBot,
  showBot,
  isTeam,
  isTeamChat,
  empList,
  crrEmpId,
  memberName,
  selectTeamEmp,
  propValue,
  stage,
  hideSidebar
}) {

  const [collapsed, setCollapsed] = useState(
    window.innerWidth < 768
  );

  useEffect(() => {
    const resize = () => {
      if (window.innerWidth < 768) setCollapsed(true);
    };

    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden relative">


      {stage === 1 ?
        <SidebarUser
          isNewChat={isNewChat}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          pageName={pageName}
          chatMarkIdInit={chatMarkIdInit}
          getChatBookmarkData={getChatBookmarkData}
          selectChatBookMark={selectChatBookMark}
          switchToAdmin={switchToAdmin}

          isTeamChat={isTeamChat}
          empList={empList}
        />
        : null}

      {stage === 2 ?
        <SidebarTeamList
          isNewChat={isNewChat}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          pageName={pageName}
          chatMarkIdInit={chatMarkIdInit}
          getChatBookmarkData={getChatBookmarkData}
          selectChatBookMark={selectChatBookMark}
          switchToAdmin={switchToAdmin}

          memberName={memberName}

          isTeamChat={true}
          crrEmpId={crrEmpId}
          empList={empList}
          selectTeamEmp={selectTeamEmp}
        />
        : null}

      {stage === 3 ?
        <SidebarUserTeam
          isNewChat={isNewChat}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          pageName={pageName}
          chatMarkIdInit={chatMarkIdInit}
          getChatBookmarkData={getChatBookmarkData}
          selectChatBookMark={selectChatBookMark}
          switchToAdmin={switchToAdmin}
          memberName={memberName}
          isTeamChat={true}
          crrEmpId={crrEmpId}
          empList={empList}
          selectTeamEmp={selectTeamEmp}
          propValue={propValue}

        />
        : null}

      {stage === 4 ?
        <SidebarReport
          isNewChat={isNewChat}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          pageName={pageName}
          chatMarkIdInit={chatMarkIdInit}
          getChatBookmarkData={getChatBookmarkData}
          selectChatBookMark={selectChatBookMark}
          switchToAdmin={switchToAdmin}
          isTeamChat={isTeamChat}
          empList={empList}
        />
        : null}


      {stage === 5 ?
        <SidebarUserTeamOverall
          isNewChat={isNewChat}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          pageName={pageName}
          chatMarkIdInit={chatMarkIdInit}
          getChatBookmarkData={getChatBookmarkData}
          selectChatBookMark={selectChatBookMark}
          switchToAdmin={switchToAdmin}
          memberName={memberName}
          isTeamChat={true}
          crrEmpId={crrEmpId}
          empList={empList}
          selectTeamEmp={selectTeamEmp}
          propValue={propValue}

        />
        : null}


      {/* MAIN AREA */}
      <div className={`flex flex-col flex-1 transition-all duration-300 ml-0 ${collapsed ? "md:ml-20" : "md:ml-64"}`}>
        <HeaderUser
          collapsed={collapsed}
          toggleSidebar={toggleSidebar}
          userDetails={userDetails}
          onLogout={onLogout}
          isTeam={isTeam}
        />
        <main className="flex-1 overflow-y-auto md:p-8 p-4 mt-20 bg-white">
          {children}
        </main>
      </div>

      {/* ✅ RIGHT SIDE FLOATING BOAT ICON */}
      {showBot &&
        <div onClick={openAIBot} className="fixed bottom-6 right-6 z-50">
          <button className="w-14 h-14 flex items-center justify-center rounded-full bg-blue-500 text-white shadow-lg hover:scale-110 hover:bg-blue-600 transition-all duration-300">
            <FaRobot className="w-7 h-7" />
          </button>
        </div>
      }


    </div>
  );
}